// Regras do formulário de cliente (máscaras e conferências). Sem tela, sem rede.

export const soDigitos = (v) => String(v || "").replace(/\D/g, "");

/** (11) 9.1234-5678 — o mesmo formato que o painel sempre gravou. */
export function mascararTelefone(v) {
  const n = soDigitos(v).slice(0, 11);
  if (!n) return "";
  if (n.length <= 2) return `(${n}`;
  if (n.length <= 3) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
  if (n.length <= 7) return `(${n.slice(0, 2)}) ${n.slice(2, 3)}.${n.slice(3)}`;
  return `(${n.slice(0, 2)}) ${n.slice(2, 3)}.${n.slice(3, 7)}-${n.slice(7)}`;
}

export function mascararCpf(v) {
  const n = soDigitos(v).slice(0, 11);
  if (n.length <= 3) return n;
  if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`;
  if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
  return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9)}`;
}

export function mascararData(v) {
  const n = soDigitos(v).slice(0, 8);
  if (n.length <= 2) return n;
  if (n.length <= 4) return `${n.slice(0, 2)}/${n.slice(2)}`;
  return `${n.slice(0, 2)}/${n.slice(2, 4)}/${n.slice(4)}`;
}

export function mascararCep(v) {
  const n = soDigitos(v).slice(0, 8);
  return n.length > 5 ? `${n.slice(0, 5)}-${n.slice(5)}` : n;
}

/** CPF com os dígitos verificadores certos. */
export function cpfValido(v) {
  const n = soDigitos(v);
  if (n.length !== 11 || /^(\d)\1{10}$/.test(n)) return false;
  const dv = (fim) => {
    let soma = 0;
    for (let i = 0; i < fim; i += 1) soma += Number(n[i]) * (fim + 1 - i);
    const r = (soma * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dv(9) === Number(n[9]) && dv(10) === Number(n[10]);
}

/** DD/MM/AAAA que existe no calendário, no passado e com idade até 120 anos. */
export function dataNascimentoValida(v, hoje = new Date()) {
  const m = String(v || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return false;
  const [d, mes, a] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const data = new Date(a, mes - 1, d);
  if (data.getFullYear() !== a || data.getMonth() !== mes - 1 || data.getDate() !== d) return false;
  return data <= hoje && a >= hoje.getFullYear() - 120;
}

/** Aniversário gravado (AAAA-MM-DD ou DD/MM/AAAA) → DD/MM/AAAA da tela. */
export function dataParaTela(v) {
  const t = String(v || "").trim();
  const iso = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : t;
}

/** DD/MM/AAAA da tela → o formato em que o cliente já estava gravado (ISO se veio ISO). */
export function dataParaGravar(tela, original) {
  const m = String(tela || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return tela || "";
  return /^\d{4}-\d{2}-\d{2}/.test(String(original || "")) ? `${m[3]}-${m[2]}-${m[1]}` : tela;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * {campo: "mensagem"} do que está errado. Só nome e telefone são obrigatórios.
 * `inicial`: o que veio gravado — e-mail, CPF, aniversário e CEP que a pessoa
 * não mexeu não travam a edição de um cliente antigo com dado fora do padrão.
 */
export function errosDoCliente(c, inicial = {}) {
  const mexeu = (k) => String(c[k] || "") !== String(inicial[k] || "");
  const e = {};
  const nome = String(c.nome || "").trim();
  if (!nome) e.nome = "Informe o nome.";
  else if (nome.replace(/[^\p{L}]/gu, "").length < 2) e.nome = "Nome muito curto.";
  const tel = soDigitos(c.telefone);
  if (!tel) e.telefone = "Informe o WhatsApp.";
  else if (tel.length < 10) e.telefone = "Faltam números: DDD + número.";
  if (c.email && mexeu("email") && !EMAIL.test(String(c.email).trim())) e.email = "E-mail incompleto.";
  if (c.cpf && mexeu("cpf") && !cpfValido(c.cpf)) e.cpf = "CPF inválido.";
  if (c.data_nascimento && mexeu("data_nascimento") && !dataNascimentoValida(c.data_nascimento)) e.data_nascimento = "Data inválida.";
  if (c.cep && mexeu("cep") && soDigitos(c.cep).length !== 8) e.cep = "CEP tem 8 números.";
  return e;
}
